// extracted by mini-css-extract-plugin
module.exports = {"form-group":"_3gCmcGUflo1pYlBtPfGnDb","mk-action-bar":"_2k3tAOEKHSK6dl5lWgaOcA","search-receipt":"_1OCC_zA6YwT8oj9YEXn18Q"};